// Branded artwork for Pixley Originals shows (public/assets/originals/).
// `cover` = key art with the show logo baked in, used for the Originals row card and the show page.
// `art`   = the same key art without the logo, for the full-width hero banner.
// `logo`  = the transparent show logo, drawn in place of the plain-text title on the hero.
// Shows listed here hide their text title on the card, because the logo is already in the cover.
//
// Keyed by show name too, because a new season's storyverse_shows row is only created when its
// first episode is published; add the id to `byId` once it exists.
const brand = (slug) => ({
  cover: `/assets/originals/${slug}-cover.webp`,
  art: `/assets/originals/${slug}-art.webp`,
  logo: `/assets/originals/${slug}-logo.webp`,
});

export const ORIGINALS_BRANDING = {
  byId: {
    '9999f7ba-c613-44b5-8be6-90ff427cc4e4': brand('the-case-crew'),
    '7e845f9b-8538-41d9-b59c-0524fb5456df': brand('curious-creek'),
  },
  byName: {
    'The Case Crew': brand('the-case-crew'),
    'Curious Creek': brand('curious-creek'),
    'The Corner Garden': brand('the-corner-garden'),
  },
};

export function getOriginalsBranding(show) {
  if (!show) return null;
  return ORIGINALS_BRANDING.byId[show.id] || ORIGINALS_BRANDING.byName[show.name] || null;
}
